import {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from 'react';

export interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface BreadcrumbContextType {
  subItems: BreadcrumbItem[];
  setSubItems: (items: BreadcrumbItem[]) => void;
  clearSubItems: () => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType>({
  subItems: [],
  setSubItems: () => {},
  clearSubItems: () => {},
});

export const BreadcrumbProvider = ({ children }: { children: ReactNode }) => {
  const [subItems, setSubItemsState] = useState<BreadcrumbItem[]>([]);

  const setSubItems = useCallback((items: BreadcrumbItem[]) => {
    setSubItemsState(items);
  }, []);

  const clearSubItems = useCallback(() => {
    setSubItemsState([]);
  }, []);

  return (
    <BreadcrumbContext.Provider
      value={{ subItems, setSubItems, clearSubItems }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
